export default "__VITE_ASSET__BOx2KXMP__"